import { Nav, Collapse, Image, Row } from "react-bootstrap";
import { List } from "react-bootstrap-icons";
import NavItem from "../common/NavItem";
import React, { useEffect, useState } from "react";
import godrejLogo from "../../assets/images/godrej.svg";
import { MENUS } from "../../helpers/constants";
import { userlogo } from "../../helpers/formatter";
import logoutarrow from "../../assets/images/logoutarrow.svg"
import { useMsal } from "@azure/msal-react";
import dashboard from "../../assets/images/dashboard.svg"
import transaction from "../../assets/images/transaction.svg"
import master from "../../assets/images/master.svg"
import adminIcon from "../../assets/images/admin.svg"
import reportIcon from "../../assets/images/report.svg"
import helpicon from "../../assets/images/help.svg"
import accesscontrolicon from "../../assets/images/accesscontrol.svg"

export default function SideBar(props) {
  let icons = { "Masters": master, "Transactions": transaction, "Admin": adminIcon, "Reopen Closed Records": accesscontrolicon, "Reports": reportIcon, "Help": helpicon }
  const [open, setOpen] = useState({});
  const [authorizedSessions, setAuthorizedSessions] = useState({});

  const { instance } = useMsal();

  function handleLogout(instance) {
    sessionStorage.clear()
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  }

  useEffect(() => {
    if (props.sidebar === "closed") {
      setOpen({});
    }
    setMenu();
  }, [props.sidebar]);

  const setMenu = () => {
    let authorizedSessionsTemp = {};
    let authorizedSessions = sessionStorage.getItem("AuthorizedSessions");

    try {
      if (authorizedSessions) {
        const parsedSessions = JSON.parse(authorizedSessions);
        // Maintain order from constants.js, use paths from constants.js
        for (let key in MENUS) {
          if (parsedSessions[key]) {
            const authorizedMenus = [];
            MENUS[key].Menus.forEach(constantMenu => {
              const isAuthorized = parsedSessions[key].Menus.some(backendMenu =>
                backendMenu.SubMenu === constantMenu.SubMenu
              );
              if (isAuthorized) {
                authorizedMenus.push(constantMenu);
              }
            });
            if (authorizedMenus.length > 0) {
              authorizedSessionsTemp[key] = { Menus: authorizedMenus };
            }
          }
        }
        setAuthorizedSessions(authorizedSessionsTemp);
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <div className="sidebar-head">
        <List className="head-toggle" onClick={() => { props.setSidebar(props.sidebar === "closed" ? "open" : "closed") }}></List>
        <div className="user-section">
          <div className="user-logo">
            {userlogo(sessionStorage.getItem("UserName"))}
          </div>
          <div className="user-info">
            <Row>
              <span className="user-name">{sessionStorage.getItem("UserName")}</span>
              <span className="user-email">{sessionStorage.getItem("Email")} </span>
            </Row>
          </div>
          <Image src={logoutarrow} onClick={(e) => handleLogout(instance)}></Image>

        </div>
      </div>
      <div className={`sidebar-body ${props.sidebar}`}>
        <Nav bsPrefix="nav-list" defaultActiveKey={"Dashboard"}>
          <NavItem menuType={"parent"} menu={"Dashboard"} path={"/"} icon={dashboard} setSidebar={props.setSidebar}></NavItem>
          {Object.keys(authorizedSessions).map((parentMenu) => {
            return <React.Fragment key={parentMenu}>
              {authorizedSessions[parentMenu]?.Menus?.length > 0 ? <React.Fragment>
                <NavItem menuType={"parent"} menu={parentMenu} setOpen={setOpen} open={open} ariaControls={parentMenu} icon={icons[parentMenu]} setSidebar={props.setSidebar}></NavItem>
                <Collapse in={open[parentMenu]}>
                  <div id={parentMenu}>
                    {authorizedSessions[parentMenu].Menus.map((item) => {
                      return <React.Fragment key={item.Path}>
                        {item.SubMenu && (
                          <NavItem
                            menuType="menu"
                            menu={item.SubMenu}
                            path={item.Path}
                            setSidebar={props.setSidebar}
                          />
                        )}
                      </React.Fragment>
                    })}
                  </div></Collapse>
              </React.Fragment>
                : <></>
              }
            </React.Fragment>
          })}

        </Nav>
        <div className="footer">
          <Image className="footer-logo mt-auto" src={godrejLogo} />
        </div>
      </div>
    </>
  );
}
